import { constructSameAddressMap } from '../utils/constructSameAddressMap'
import { SupportedChainId } from './chains'

type AddressMap = { [chainId: number]: string }

export const UNI_ADDRESS: AddressMap = constructSameAddressMap('0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984')

// SAMVI Info: addresses for hydra v3 contracts and v2 contracts
// Hydra Chain
const HYDRACHAIN_V2_CORE_FACTORY_ADDRESSES = '0x9DCBe256259E8EE82103F88164C727e133B83030'
// const HYDRACHAIN_V2_ROUTER_ADDRESSES = '0x352d2Db98842FebbcBe50a50A6fbF7A56C176079'

const HYDRACHAIN_V3_CORE_FACTORY_ADDRESSES = '0x664bC90358785F6C02c7e26696FE7E908CebAB86'
const HYDRACHAIN_MULTICALL_ADDRESS = '0x42320aDeF5D9B5890292251f35A89B39EA42d61c'
const HYDRACHAIN_TICK_LENS_ADDRESSES = '0x6C1EDf5bDEcaa1e87627c4Bacf58CB954c6A1869'

const HYDRACHAIN_SWAP_ROUTER_ADDRESSES = '0x9740a64B7F448E4fcE0Db5c3f0F0a0Ae1796e643' // Router 02 from swap-router-contracts
const HYDRACHAIN_NONFUNGIBLE_POSITION_MANAGER_ADDRESSES = '0x2Ff62B6EA2d6ED7bbcE8cc51b8D7402AeB671335'
// const HYDRACHAIN_V3_MIGRATOR_ADDRESSES = '0x107EdE7C81CA2a91Bc54b5CACe30830daff538BE'
const HYDRACHAIN_QUOTER_ADDRESSES = '0x2f47EDDca7Ec038E542541E74FA8CA9558718773'

// Hydra Testnet
const HYDRACHAIN_V2_CORE_FACTORY_ADDRESSES_TESTNET = '0x2eF24A912d0bFD6148A1a291C958266a4aB132e9'
// const HYDRACHAIN_V2_ROUTER_ADDRESSES_TESTNET = '0x41896612F0746cD8c9521489744e7961d77a8923'

const HYDRACHAIN_V3_CORE_FACTORY_ADDRESSES_TESTNET = '0x3887e4C46Bb809d0345dC1d8f0E4e783424ACEB2'
const HYDRACHAIN_MULTICALL_ADDRESS_TESTNET = '0xdbF3F5164A41FAbD326A6f5F74FC53ece7869f39'
const HYDRACHAIN_TICK_LENS_ADDRESSES_TESTNET = '0x870df4B8FCC2EaC7ad5cdaF0B89d5e1f99FD5945'

const HYDRACHAIN_SWAP_ROUTER_ADDRESSES_TESTNET = '0xBCA3A954223718dba56b1649da4AcE1c6b0062F5' // Router 02 from swap-router-contracts
const HYDRACHAIN_NONFUNGIBLE_POSITION_MANAGER_ADDRESSES_TESTNET = '0x8ed4D244F25F37B35ee4778857da904D25F392Ca'
// const HYDRACHAIN_V3_MIGRATOR_ADDRESSES_TESTNET = '0x0E4c31FABe0C7A3F690d71f4f4a34e66ee9ba5a2'
const HYDRACHAIN_QUOTER_ADDRESSES_TESTNET = '0xDc92b0FcacbF94B7cF0558a322e4AC89beC0786c'

// Hydra Devnet
const HYDRACHAIN_V2_CORE_FACTORY_ADDRESSES_DEVNET = '0x28cE260b7E028e4c4AA1e265ED61D517Bf4CFa4D'
// const HYDRACHAIN_V2_ROUTER_ADDRESSES_DEVNET = '0xA4F50366b6F2CB220E7012CeA98f2FB81624d143'

const HYDRACHAIN_V3_CORE_FACTORY_ADDRESSES_DEVNET = '0xd555277891c118109b8bd066249D541FF4f993A4'
const HYDRACHAIN_MULTICALL_ADDRESS_DEVNET = '0x53E0043bcc270CC3f4222604b1Dbb0a735366bbD'
const HYDRACHAIN_TICK_LENS_ADDRESSES_DEVNET = '0xe0ABF31F69Ea2F1886CF550Cc5e272Ec968Cd918'

const HYDRACHAIN_SWAP_ROUTER_ADDRESSES_DEVNET = '0xfF28bb76BA331270ff6d18B61F325b59C974a7f6' // Router 02 from swap-router-contracts
const HYDRACHAIN_NONFUNGIBLE_POSITION_MANAGER_ADDRESSES_DEVNET = '0xeFF3D3b379294A09147D6cD3a5ac1b9B8a78341E'
// const HYDRACHAIN_V3_MIGRATOR_ADDRESSES_DEVNET = '0xA205156Dba14584af6A5708Cc8b0CE666986De85'
const HYDRACHAIN_QUOTER_ADDRESSES_DEVNET = '0xEEDe86D3e3D88A1b2b35814Bc7465585B370FB16'

const V3_STAKER_MAINNET = '0x9115a99b6E555365a8dAC61dd9aAB9D82cBA8EDa'
const V3_STAKER_TESTNET = '0xb2721f46D40eb85c14BF017A18D9faAb4B12d930'

// ANI Integration Contract Addresses (Mainnet only)
const ANI_TOKEN_ADDRESS = '0xa2f1C73FE7705c80f65D4db43529220d5B4fb154'
const ANI_ADAPTER_ADDRESS = '0xc928Fc690b3b886E6513a274f7beb48dDBF17181'
const ANI_ORACLE_ADDRESS = '0xb8bf41E765d14A0705EddbD2b9008133fDDaC51A'

export const V2_FACTORY_ADDRESSES: AddressMap = {
  [SupportedChainId.HYDRA]: HYDRACHAIN_V2_CORE_FACTORY_ADDRESSES,
  [SupportedChainId.TESTNET]: HYDRACHAIN_V2_CORE_FACTORY_ADDRESSES_TESTNET,
  [SupportedChainId.DEVNET]: HYDRACHAIN_V2_CORE_FACTORY_ADDRESSES_DEVNET,
}

/* V3 Contract Addresses */
export const V3_CORE_FACTORY_ADDRESSES: AddressMap = {
  [SupportedChainId.HYDRA]: HYDRACHAIN_V3_CORE_FACTORY_ADDRESSES,
  [SupportedChainId.TESTNET]: HYDRACHAIN_V3_CORE_FACTORY_ADDRESSES_TESTNET,
  [SupportedChainId.DEVNET]: HYDRACHAIN_V3_CORE_FACTORY_ADDRESSES_DEVNET,
}

export const MULTICALL_ADDRESS: AddressMap = {
  [SupportedChainId.HYDRA]: HYDRACHAIN_MULTICALL_ADDRESS,
  [SupportedChainId.TESTNET]: HYDRACHAIN_MULTICALL_ADDRESS_TESTNET,
  [SupportedChainId.DEVNET]: HYDRACHAIN_MULTICALL_ADDRESS_DEVNET,
}

export const SWAP_ROUTER_ADDRESSES: AddressMap = {
  [SupportedChainId.HYDRA]: HYDRACHAIN_SWAP_ROUTER_ADDRESSES,
  [SupportedChainId.TESTNET]: HYDRACHAIN_SWAP_ROUTER_ADDRESSES_TESTNET,
  [SupportedChainId.DEVNET]: HYDRACHAIN_SWAP_ROUTER_ADDRESSES_DEVNET,
}

export const MERKLE_DISTRIBUTOR_ADDRESS: AddressMap = {}

export const ARGENT_WALLET_DETECTOR_ADDRESS: AddressMap = {}

export const QUOTER_ADDRESSES: AddressMap = {
  [SupportedChainId.HYDRA]: HYDRACHAIN_QUOTER_ADDRESSES,
  [SupportedChainId.TESTNET]: HYDRACHAIN_QUOTER_ADDRESSES_TESTNET,
  [SupportedChainId.DEVNET]: HYDRACHAIN_QUOTER_ADDRESSES_DEVNET,
}

export const NONFUNGIBLE_POSITION_MANAGER_ADDRESSES: AddressMap = {
  [SupportedChainId.HYDRA]: HYDRACHAIN_NONFUNGIBLE_POSITION_MANAGER_ADDRESSES,
  [SupportedChainId.TESTNET]: HYDRACHAIN_NONFUNGIBLE_POSITION_MANAGER_ADDRESSES_TESTNET,
  [SupportedChainId.DEVNET]: HYDRACHAIN_NONFUNGIBLE_POSITION_MANAGER_ADDRESSES_DEVNET,
}

export const ENS_REGISTRAR_ADDRESSES: AddressMap = {}

export const TICK_LENS_ADDRESSES: AddressMap = {
  [SupportedChainId.HYDRA]: HYDRACHAIN_TICK_LENS_ADDRESSES,
  [SupportedChainId.TESTNET]: HYDRACHAIN_TICK_LENS_ADDRESSES_TESTNET,
  [SupportedChainId.DEVNET]: HYDRACHAIN_TICK_LENS_ADDRESSES_DEVNET,
}

export const V3_STAKER_ADDRESSES: AddressMap = {
  [SupportedChainId.HYDRA]: V3_STAKER_MAINNET,
  [SupportedChainId.TESTNET]: V3_STAKER_TESTNET,
}

// ANI Integration Addresses (Mainnet only)
export const ANI_TOKEN_ADDRESSES: AddressMap = {
  [SupportedChainId.HYDRA]: ANI_TOKEN_ADDRESS,
}

export const ANI_ADAPTER_ADDRESSES: AddressMap = {
  [SupportedChainId.HYDRA]: ANI_ADAPTER_ADDRESS,
}

export const ANI_ORACLE_ADDRESSES: AddressMap = {
  [SupportedChainId.HYDRA]: ANI_ORACLE_ADDRESS,
}

// ==========================================
// Governance Contract Addresses (Precompiles)
// These are the same across all Hydra networks
// ==========================================

export const HYDRA_CHAIN_ADDRESS: AddressMap = {
  [SupportedChainId.HYDRA]: '0x0000000000000000000000000000000000000101',
  [SupportedChainId.TESTNET]: '0x0000000000000000000000000000000000000101',
  [SupportedChainId.DEVNET]: '0x0000000000000000000000000000000000000101',
}

export const HYDRA_STAKING_ADDRESS: AddressMap = {
  [SupportedChainId.HYDRA]: '0x0000000000000000000000000000000000000104',
  [SupportedChainId.TESTNET]: '0x0000000000000000000000000000000000000104',
  [SupportedChainId.DEVNET]: '0x0000000000000000000000000000000000000104',
}

export const HYDRA_VAULT_ADDRESS: AddressMap = {
  [SupportedChainId.HYDRA]: '0x0000000000000000000000000000000000000106',
  [SupportedChainId.TESTNET]: '0x0000000000000000000000000000000000000106',
  [SupportedChainId.DEVNET]: '0x0000000000000000000000000000000000000106',
}

export const HYDRA_DELEGATION_ADDRESS: AddressMap = {
  [SupportedChainId.HYDRA]: '0x0000000000000000000000000000000000000107',
  [SupportedChainId.TESTNET]: '0x0000000000000000000000000000000000000107',
  [SupportedChainId.DEVNET]: '0x0000000000000000000000000000000000000107',
}

export const APR_CALCULATOR_ADDRESS: AddressMap = {
  [SupportedChainId.HYDRA]: '0x0000000000000000000000000000000000000109',
  [SupportedChainId.TESTNET]: '0x0000000000000000000000000000000000000109',
  [SupportedChainId.DEVNET]: '0x0000000000000000000000000000000000000109',
}

export const REWARD_WALLET_ADDRESS: AddressMap = {
  [SupportedChainId.HYDRA]: '0x0000000000000000000000000000000000000110',
  [SupportedChainId.TESTNET]: '0x0000000000000000000000000000000000000110',
  [SupportedChainId.DEVNET]: '0x0000000000000000000000000000000000000110',
}

export const PRICE_ORACLE_ADDRESS: AddressMap = {
  [SupportedChainId.HYDRA]: '0x0000000000000000000000000000000000000112',
  [SupportedChainId.TESTNET]: '0x0000000000000000000000000000000000000112',
  [SupportedChainId.DEVNET]: '0x0000000000000000000000000000000000000112',
}
